import { normalizePayloadText } from '~/utils/societePayloadBuilder/htmlEntities';
import { asString } from '~/utils/societePayloadBuilder/parseHelpers';
import { isHttpsUrl, isInternalRoute } from '~/utils/societePayloadBuilder/url';
import { validateRequiredString } from '~/utils/societePayloadBuilder/validationHelpers';

import { isValidPayloadDateTime, toDateTimeLocal, toPayloadIsoDateTime } from './dateTime';

export const PREVIEW_REQUIRED = '[required]';

export function payloadText(value: string): string {
  return normalizePayloadText(value);
}

export function previewRequiredValue(value: string): string {
  const normalizedValue = payloadText(value);
  return normalizedValue ? normalizedValue : PREVIEW_REQUIRED;
}

export function parseOptionalExpiresAt(value: unknown): string {
  return toDateTimeLocal(asString(value));
}

export function buildOptionalExpiresAt(value: string): string | undefined {
  const trimmed = value.trim();
  return trimmed ? toPayloadIsoDateTime(trimmed) : undefined;
}

export function previewExpiresAt(value: string): string | undefined {
  return buildOptionalExpiresAt(value);
}

export function validateOptionalExpiresAt(value: string, label: string, errors: Array<string>) {
  if (!value.trim()) {
    return;
  }

  if (!isValidPayloadDateTime(value)) {
    errors.push(`${label} must be a valid datetime`);
  }
}

export function validateCtaLink(value: string, label: string, errors: Array<string>) {
  validateRequiredString(value, label, errors);
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return;
  }
  if (isHttpsUrl(trimmedValue) || isInternalRoute(trimmedValue)) {
    return;
  }
  errors.push(`${label} must be either an https:// URL or an internal route starting with /`);
}

export function validateOptionalCtaLink(value: string, label: string, errors: Array<string>) {
  if (!value.trim()) {
    return;
  }
  validateCtaLink(value, label, errors);
}
